module.exports = __webpack_public_path__ + "img/default.d28bc2b6.jpg";